import {useTranslation} from "next-i18next"
import Image from "next/image"
import {useRouter} from "next/router"
import React, {useContext, useState} from "react"
import Typography from "../../reusable/Typography/Typography"
import Button from "../../reusable/components/Button"
import LayoutContext from "../../../context/LayoutContext"
import DataContext from "../../../context/DataContext"
import {formatImageSrc} from "../../../strapi/strapiHelpers"
import {ModalContext} from "../../../context/ModalContext"
import BookAppointmentModalContent from "../../reusable/ModalsContent/BookAppointmentModalContent"
import AskAiAboutMbp from "../../reusable/AskAiAboutMbp"
import MobileModal from "../../reusable/MobileModal"
import RyderAiStaticTile from "../../bikesCollection/staticTiles/RyderAiStaticTile"

const LeadMagnetTypes = {
	ai: "isAi",
	consultation: "isConsultation",
	link: "isLeadMagnetWithLink"
}
function BrandWorldLeadMagnets() {
	const {brandWorld} = useContext(DataContext)
	const {isMobile} = useContext(LayoutContext)
	const {setModalContent, openModal, openDrawer, closeModal} = useContext(ModalContext)
	const router = useRouter()
	const [isOpen, setIsOpen] = useState<boolean|null>(false)
	const {t} = useTranslation()
	const handleMagnetBtnClick = (type, link = "") => {
		switch (type) {
			case LeadMagnetTypes.link:
				router.push(link)
				break
			case LeadMagnetTypes.consultation:
				setModalContent(<BookAppointmentModalContent closeModal={closeModal}/>)
				openModal()
				break

			case LeadMagnetTypes.ai:
				if (isMobile === true) {
					setIsOpen(true)
				} else {
					setModalContent(<AskAiAboutMbp

					/>)
					openDrawer()
				}

				break
			default:
				router.push(link)
		}
	}

	return (
		<><MobileModal modalOpen={isOpen}
			isAiModal
			handleClose={() => setIsOpen(false)} >
			<div style={{minHeight: "60dvh", overflowY: "auto"}}>
				<RyderAiStaticTile
					customLayoutClassname="d-flex align-items-start justify-content-start gap-3 col-12 h-100 flex-column" />
			</div>
		</MobileModal>
		<div style={{marginTop: "120px"}}
			className="d-flex align-items-center justify-content-start flex-column justify-content-lg-center mb-4">
			<Typography variant="bodyLgBlack"
				className="typography-amount "
				style={{textAlign: "center", maxWidth: "1200px"}}>
				{brandWorld?.leadMagnetsSectionTitle}
			</Typography>
			<div style={{gap: "40px", maxWidth: "100%", overflowX: "auto"}}
				className=" d-flex col-12 align-items-center px-2 hide-overflow-scrollbar justify-content-start justify-content-xxl-center mb-4 ">
				{brandWorld?.leadMagnets?.map(({image, description, mobileImage, btn_label, title, btn_href, leadMagnetType, btn_icon}, index) =>
					<div
						key={index}
						className="brand-world-lead-magnets">
						<div style={{gap: "32px"}}
							className="d-flex align-items-start justify-content-start flex-column">
							{mobileImage?.data?.attributes?.url || image?.data?.attributes?.url ? <div className="d-md-block d-none">
								<Image
									src={formatImageSrc(mobileImage?.data?.attributes?.url || image?.data?.attributes?.url)}
									style={{borderRadius: "16px", height: "350px", width: "413px"}}
									height={350}
									layout="fixed"
									objectFit="cover"
									width={413} />
							</div> : null}
							{mobileImage?.data?.attributes?.url || image?.data?.attributes?.url ? <div className="d-md-none d-block">
								<Image
									src={formatImageSrc(mobileImage?.data?.attributes?.url || image?.data?.attributes?.url)}
									style={{
										borderRadius: "16px",
										height: "216px",
										width: "288px"
									}}
									objectFit="cover"
									height={216}
									layout="fixed"
									width={288} /></div> : null}
							<div className="d-flex align-items-start justify-content-start flex-column"
								style={{gap: "8px"}}>
								<Typography variant="bodySmBold"
									style={{fontSize: "20px", lineHeight: "32px"}}>{title}</Typography>
								<Typography variant="bodySm"
									style={{fontSize: "16px", lineHeight: "24px", opacity: "0.6"}}>{description}</Typography>
							</div>
						</div>
						<Button onClick={() => handleMagnetBtnClick(leadMagnetType, btn_href)}
							label={t(btn_label)}
							icon={<Image src={formatImageSrc(btn_icon?.data?.attributes?.url)}
								width={24}
								height={24}
								layout="fixed"
							/>}
							fontSizeSmall
							className={`${leadMagnetType === LeadMagnetTypes.ai ? "try-ai" : ""}`}
							textColor="#fff"
							bgColor={brandWorld?.buttonsBackgroundColor} />
					</div>)}
			</div>
		</div>
		</>
	)
}

export default BrandWorldLeadMagnets
